<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="content-chapter3" id="calibre_toc_8"><a href="#/OEBPS/5Ingredient_split_006#_idTextAnchor023">Breakfast All Day<span id="_idTextAnchor006"></span> </a></p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Mini Meatball Breakfast Hash</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Quinoa Breakfast Bowl</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Keto Trucker’s Breakfast</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Crispy Crepes Benedict</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Post-Workout Protein Smoothie</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">No-Bake Granola</p>
<p class="recipes-chapters_recipes-chapter-recipes-pages">Breakfast Tacos</p>
<div class="calibre1" id="calibre_pb_52"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_030.vue?464ec6e0